/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { tariffConstants, tariffsActions } from '../../modules/tariffs/actions';
import { Auth } from '../../modules/auth/Auth';
import SelectFromRest from '../../components/Form/SelectFromRest';
import I18n from '../../core/i18n';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import { store } from '../../core/store';
import { tariffsReducers } from '../../modules/tariffs/reducers';

class TariffSelectApi extends Component {
    constructor(props) {
        super(props);
        store.injectReducer('tariffsReducers', tariffsReducers);
        this.state = {
            tariffsSelect: null,
        };
        this.handleSelectFunc = this.props.callbackSelect;
    }

    componentDidMount() {
        this.loadTariffsList();
    }

    loadTariffsList = () => {
        const { dispatch } = this.props;
        dispatch(
            tariffsActions.getTariffsList(
                FormGeneralHelper.getUrl('/tariffs'),
                [
                    { name: 'customerId', value: Auth.getUserPlatformResellerId() },
                    { name: 'deleted', value: false },
                ],
                null,
                tariffConstants.LIST
            )
        );
    };

    render() {
        const { tariffsSelect, tariffIdSelected, tariffIdState, stateName } = this.props;
        return (
            <SelectFromRest
                callback={this.handleSelectFunc}
                required={true}
                restElements={tariffsSelect}
                stateName={stateName}
                stateObjectState={tariffIdState}
                selectedValue={tariffIdSelected}
                propKey="id"
                propValue="tariffName"
                addEmpty={true}
                displayEmpty={true}
                emptyLabel={I18n.t('tariffs:t.choose_tariff')}
                label={I18n.t('tariffs:t.choose_tariff')}
            />
        );
    }
}

TariffSelectApi.propTypes = {
    classes: PropTypes.object.isRequired,
    callbackSelect: PropTypes.func.isRequired,
    stateName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
    const { tariffsReducers } = state;
    if (tariffsReducers === undefined) {
        return { ...state };
    }

    let tariffsSelect = null;
    if (tariffsReducers.collections) {
        tariffsSelect = tariffsReducers.collections;
    }
    return {
        tariffsSelect: tariffsSelect,
    };
};

const tariff = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Tariff = tariff(TariffSelectApi);
export default Tariff;
